import React from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";

import { LiveLectureStatsDto } from "../../interfaces";

type TProps = {
  stats?: LiveLectureStatsDto;
  isLoading?: boolean;
};

export const LiveLectureStats: React.FC<TProps> = ({ stats, isLoading }) => {
  const { t } = useTranslation();

  const items = [
    {
      label: t("total"),
      value: stats?.total ?? 0,
      icon: "ri-live-line",
      bgcolor: "primary",
    },
    {
      label: t("publishedStandaloneLectures"),
      value: stats?.published ?? 0,
      icon: "ri-checkbox-circle-line",
      bgcolor: "success",
    },
    {
      label: t("unpublishedStandaloneLectures", {
        defaultValue: "Unpublished",
      }),
      value: stats?.unpublished ?? 0,
      icon: "ri-draft-line",
      bgcolor: "secondary",
    },
    {
      label: t("upcomingLiveLectures", { defaultValue: "Upcoming" }),
      value: stats?.incoming ?? 0,
      icon: "ri-calendar-event-line",
      bgcolor: "info",
    },
  ];

  return (
    <Row className="g-3 mb-3">
      {items.map((item) => (
        <Col sm={6} xl={3} key={item.label}>
          <Card className="card-animate mb-0">
            <CardBody className="py-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="text-muted mb-2">{item.label}</p>
                  <h4 className="fs-22 fw-semibold mb-0">
                    {isLoading ? (
                      <Spinner size="sm" />
                    ) : (
                      <CountUp start={0} end={item.value} duration={2} />
                    )}
                  </h4>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span
                    className={`avatar-title rounded fs-3 bg-${item.bgcolor}-subtle text-${item.bgcolor}`}
                  >
                    <i className={item.icon}></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
